import React, { useEffect,useState } from 'react';
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
} from "reactstrap";




const OrderStatus = (props) => {
    const [OrderStatusData, setOrdersstatusdata] = useState([])

    const company = props.company;

    useEffect(()=>{

        const getData = async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getOrdersbystores?company=${company}`);
            const data = await res.json();
            setOrdersstatusdata(data)
            
        }

        getData();

    },[company])


    return (
        <React.Fragment>
            <Col xl={4}>
                <Card>
                    <CardBody>
                        <CardTitle>Orders by store</CardTitle>
                        <div>
                            <ul className="list-unstyled">
                                {OrderStatusData.map((item, key) => (<li key={key} className="py-3">
                                    <div className="d-flex">
                                        <div className="avatar-xs align-self-center me-3">
                                            <div className="avatar-title rounded-circle bg-light text-primary font-size-18">
                                                <i className='ri-store-line'></i>
                                            </div>
                                        </div>

                                        <div className="flex-grow-1">
                                            <p className="text-muted mb-2">{item.storename}</p>
                                            <div className="progress progress-sm animated-progess">
                                                <div className={"progress-bar bg-success"} role="progressbar" style={{ width: item.width  }} aria-valuenow={item.width} aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                        </div>
                                    </div>
                                </li>))}
                            </ul>
                        </div>
                        
                        <hr />

                        <div className="text-center">
                            <Row>
                                {OrderStatusData.map((item, key) => (<div key={key} className="col-4">
                                    <div className="mt-2">
                                        <p className="text-muted mb-2">{item.storename}</p>
                                        <h5 className="font-size-16 mb-0">{item.width} orders</h5>
                                    </div>
                                </div>))}

                            </Row>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    )
}

export default OrderStatus;